import { Outlet } from 'react-router-dom';

export function SettingsLayout() {
  return (
    <div className="min-w-0">
      <Outlet />
    </div>
  );
}
